import React from 'react';
import AuthModal from '@/components/auth/AuthModal';

interface DownloadAuthModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: () => void;
  sequenceId?: string;
  sequenceTitle?: string;
  sequenceArtist?: string;
  isFree?: boolean;
  price?: number;
  isOwner?: boolean;
  albumCoverUrl?: string;
}

/**
 * Download-specific authentication modal.
 * Reuses the base AuthModal visuals/flow but with copy tailored for downloads.
 */
const DownloadAuthModal: React.FC<DownloadAuthModalProps> = ({
  isOpen,
  onClose,
  onSuccess,
  sequenceId,
  sequenceTitle,
  sequenceArtist,
  isFree,
  price,
  isOwner,
  albumCoverUrl,
}) => {
  return (
    <AuthModal
      isOpen={isOpen}
      onClose={onClose}
      onSuccess={onSuccess}
      title="Sign up to download"
      description="Save to your library, re-download anytime"
      sequenceId={sequenceId}
      sequenceTitle={sequenceTitle}
      sequenceArtist={sequenceArtist}
      isFree={isFree}
      price={price}
      isOwner={isOwner}
      albumCoverUrl={albumCoverUrl}
    />
  );
};

export default DownloadAuthModal;


